import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import FallbackErrorMessage from '../../../../utils/errors/FallbackMessage'
import { EInvoiceCockpit } from '../components'

export const EInvoiceCockpitPage: React.FC = () => {
  return (
    <ErrorBoundary FallbackComponent={FallbackErrorMessage}>
      <EInvoiceCockpit />
    </ErrorBoundary>
  )
}
